/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

/**
 * @module  org
 * @description  This module provides interactions with an org
 */

var xtend = require("xtend");

var createManageGroup = require("./managegroup");

module.exports = function (config, { get, newGet }, post, upload) {
	return {
		dataRetention: {
			update: (retention) => {
				return post("/v2/org/data/retention", {
					retention
				});
			}
		},
		names: (orgIds) => newGet("/v2/org/names", {orgIds}),
		group: {
			list: get_group_list,
			update: update_group,
			data: get_group_data,
			create: create_group,
			settings: group_settings,
			customProperties: group_custom_properties,
			current: {
				update: update_current_group,
				data: get_current_group_data,
				id: get_current_group,
				confirm: group_confirm_viewed,
				check: group_check_viewed,
			},
			calls: {
				staff: group_calls_staff,
				users: group_calls_users,
				from: group_calls_member,
				all: group_calls_all,
				report: group_calls_report
			},
			members: get_group_members_list,
			data_public: get_group_public_data
		},
		users: {
			data: get_users_full_data,
			dataList: get_users_full_data_list,
			emr: get_users_from_emr,
			list: get_group_user_list,
			listByStatus: get_group_user_by_status,
			listByManageGroup: get_group_user_by_managegroup,
			listByStatusManageGroup: get_group_user_by_status_managegroup,
			listWithFilters,
			listByCurrentStatus,
			assigned: get_group_users_assigned,
			list_basic: get_group_user_basic,
			create: create_group_user,
			createMobile: create_group_mobile,
			createSimplified: create_group_simplified,
			update: update_nameonly,
			patient: {
				update: (who, data) => post("/v2/org/users/update/data", {who, data})
			},
			remove: remove_group_user,
			token: get_user_token,
			status: get_user_statuses,
			compliant: get_user_compliancy,
			typeUpdate: update_user_type,
			deviceInfoUpdate: update_user_device_info,
			patients,
			patientState,
			total: {
				patients: get_total_patients,
				red: get_total_red_patients,
				yellow: get_total_yellow_patients,
				green: get_total_green_patients,
			},
			contacts: {
				list: list_user_contacts
			},
			inactive: {
				update: update_inactive,
				list: get_group_status,
				status: get_user_status
			},
			careplan: {
				data: get_user_careplan,
				changes: {
					pending: get_confirmed_changes,
					committed: post_committed_changes,
					notification: show_confirmed_users
				},
				number: {
					update: update_careplan_number,
					data: get_careplan_number
				}
			},
			survey: {
				history: {
					group: group_history
				},
				settings: {
					set: auto_survey_settings,
					get: auto_survey_retrieve
				}
			},
			invitation: {
				send: send_email_invitation,
				list: get_email_invitation,
				remove: remove_email_invitation,
				list_existing: get_existing_invitation,
				remove_existing: remove_existing_invitation,
				incoming: get_incoming_user_invitation,
				accept: accept_incoming_user_invitation,
				deny: deny_incoming_user_invitation
			},
			recentReadings: {
				ofUser: get_recent_readings_of_user,
				ofUsers: get_recent_readings_of_users,
				ofGroup: get_recent_readings_of_group,
			},
			testmode: {
				enable: handle_testmode_enable,
				enableBulk: handle_testmode_enable_bulk,
				disable: handle_testmode_disable,
				disableBulk: handle_testmode_disable_bulk
			}
		},
		patients: {
			list: list_patients,
		},
		manage: {
			managers: list_user_managers,
			add: add_user_manager,
			addMulti: add_user_manager_multi,
			remove: remove_user_manager,
			removeMulti: remove_user_manager_multi,
			permissions: {
				list: permissionList,
				update: permissionUpdate
			},
			workflow: {
				actions: workflow_action_history,
				ongoing: workflow_ongoing,
				definitions: workflow_definitions
			},
			defaultPermissions: {
				set: set_default_manager_permissions,
				get: get_default_manager_permissions
			},
			presetPermissions: {
				list: list_preset_manager_permissions,
				add: create_preset_manager_permissions,
				remove: remove_preset_manager_permissions,
				update: update_preset_manager_permissions
			}
		},
		administrator: {
			set: set_administrator,
			remove: remove_administrator
		},
		staff: {
			orgData: getStaffOrgData,
			list: list_staff,
			add: add_staff,
			remove: remove_staff,
			clearverification: clearverification_staff,
			preferences: {
				get: get_preferences,
				set: set_preferences
			},
			get: {
				autologout: get_autologout,
				multifactor: get_multifactor
			}
		},
		urgency: {
			groupHistory: list_group_urgency,
			addStaff: add_urgency_staff,
			remove: remove_urgency_contact,
			list: list_urgency_contacts,
			preferences: {
				get: get_urgency_preferences,
				update: update_urgency_preferences
			}
		},
		reminders: {
			groupHistory: list_group_reminder_history,
			groupResponseHistory: list_group_reminder_response_history,
			groupPendingHistory: list_group_reminder_pending_history,
			groupData: list_group_reminder_data,
			templates: {
				list: templates_list,
				create: templates_create,
				update: templates_update,
				remove: templates_remove
			}
		},
		managers: {
			list: list_org_managers,
			add: add_org_manager,
			remove: remove_org_manager,
			autologout: {
				get: get_org_autologout,
				set: set_org_autologout
			},
			multifactor: {
				get: get_org_multifactor,
				set: set_org_multifactor
			}
		},
		machines: {
			listUser: list_machines_user,
			listStaff: list_machines_staff
		},
		devices: {
			list: list_devices,
			listUser: list_devices_user,
			data: get_devices_data,
			associate: associate_devices,
			unassociate: unassociate_devices,
			contact: set_device_contact,
			update: update_devices,
			wander: {
				history: wander_history,
				latest: wander_latest
			},
			fall: fall_history,
			battery: battery_level,
			latest: {
				activity: latest_steps,
				bloodsugar: latest_bloodsugar,
				bloodpressure: latest_bloodpressure,
				bodytemperature: latest_bodytemperature,
				bloodoxygen: latest_bloodoxygen,
				weight: latest_weight
			},
			activity: {
				steps: {
					cumulative: steps_cumulative_history
				}
			},
			health: {
				glucose: blood_sugar_history,
				weight: weight_history,
				bloodpressure: bloodpressure_history,
				bloodoxygen: bloodoxygen_history,
				bodytemperature: bodytemperature_history,
				custom: getCustomIndicatorHistory,
			}
		},
		metrics: {
			list: metrics_listHistory,
			listCumulative: metrics_listCumulative,
			listCumulativeTotal: metrics_listCumulative_total,
			listCumulativeTotalInactive: metrics_listCumulative_total_inactive,
			listCumulativeTotalActive: metrics_listCumulative_total_active
		},
		forms: {
			listGroupSubmissionChanges: forms_list_organization_group_changes,
			listGroupCombinedSubmissionChanges: forms_list_organization_group_combined_changes,
			confirmGroupSubmissionChange: forms_mark_confirm__combined_changes,
			listGroupSubmissions: forms_list_organization_group_submissions,
			listGroup: forms_list_organization_group,
			listOrg: forms_list_organization,
			listType: forms_list_type,
			addUserForm: forms_add_user_form,
			removeUserForm: forms_remove_user_form,
			listStaffForms: forms_list_staff_forms,
			addStaffForm: forms_add_staff_form,
			removeStaffForm: forms_remove_staff_form,
			create: forms_create,
			update: forms_update,
			remove: forms_remove,
			core: {
				list: list_note,
				create: create_note,
				update: update_note,
				remove: remove_note
			}
		},
		workflow: {
			listOrg: workflow_list_organization,
			create: workflow_create,
			update: workflow_update,
			remove: workflow_remove,
			actions: workflow_action_history,
			ongoing: workflow_ongoing,
			definitions: workflow_definitions,
			externals: {
				link: link_workflow_externals,
				unlink: unlink_workflow_externals
			},
			autostart: {
				set: workflow_autostart_set,
				get: workflow_autostart_get,
				remove: workflow_autostart_remove
			}
		},
		callgroups: {
			create: callgroup_create,
			remove: callgroup_remove,
			members: {
				add: callgroup_member_add,
				remove: callgroup_member_remove
			},
			update: callgroup_update,
			list: callgroup_list
		},
		id: get_org_id,
		data: get_org_data,
		public: get_public_org_data,
		indicators: get_organization_indicators,
		resources: {
			create: resource_create,
			remove: resource_remove,
			update: resource_update,
			user: {
				add: resource_user_add,
				remove: resource_user_remove,
				list: resource_user_list
			},
			list: resource_list,
			listAll: resource_list_all
		},
		livechat: {
			create: livechat_create,
			remove: livechat_remove,
			update: livechat_update,
			members: {
				add: livechat_member_add,
				remove: livechat_member_remove
			},
			list: livechat_list
		},
		thresholds: {
			list: thresholds_list,
			update: thresholds_update,
			default: {
				list: thresholds_default_list,
				update: thresholds_default_update
			}
		},
		compliant: {
			list: compliant_list,
			update: compliant_update
		},
		managergroups: createManageGroup(config, get, post),
		stats: require("./stats")(config, get, post),
		tables: require("./tables")(config, get, post),
		options: require("./options")(config, get, post),
		reports: require("./reports")(config, get, post),
		customReports: require("./customreports")(config, get, post),
		audit: {
			fetch: fetchAuditLog
		}
	};

	function get_organization_indicators() {
		return get("/v2/org/indicators");
	}

	function getCustomIndicatorHistory(indicatorId, user, page, start, end) {
		if (!user) user = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";

		return get(`/v2/org/observations/indicators/${indicatorId}/cumulative`, {
			page, user, start, end
		});
	}

	function get_group_members_list(query, page) {
		if (!query) query = "";
		if (!page) page = "";
		return get("/v2/org/group/member/list", {
			query: query,
			page: page
		});
	}

	function get_group_public_data(group) {
		return get("/v2/org/group/data/public", {
			group: group
		});
	}

	function workflow_list_organization() {
		return get("/v2/org/workflow/org/list");
	}

	function workflow_create(data) {
		return post("/v2/org/workflow/create", data);
	}

	function workflow_update(workflow, data) {
		var toSubmit = xtend(data, {
			workflow: workflow
		});
		return post("/v2/org/workflow/update", toSubmit);
	}

	function workflow_remove(workflow) {
		return post("/v2/org/workflow/remove", {
			workflow: workflow
		});
	}

	/**
	 * Returns a list of form submissions by members of a group with various parameters to filter results
	 * @param {String or Array} user user(s) _id(s) of interest
	 * @param {String or Array} forms form(s) _id of interest
	 * @param {String or Number} page number indicating the page of results (1 page = 32 documents)
	 * @param {String} start formatted date for start of period of interest
	 * @param {String} end  formatted date for end of period of interest
	 * @param {String or Array} editor form editor(s) _id(s) of interest
	 */
	function forms_list_organization_group_submissions(user, forms, page, start, end, editor) {
		if (!user) user = "";
		if (!forms) forms = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!editor) editor = "";

		return get("/v2/org/forms/submissions/history", {
			page: page,
			user: user,
			forms: forms,
			start: start,
			end: end,
			editor: editor
		});
	}

	/**
	 * Returns a list of form submissions of type 'submission:change' by members of a group for CCP v2.0.
	 * There are various parameters to filter results:
	 * @param {String or Array} user user(s) _id(s) of interest, the 'owners' in the db
	 * @param {String or Array} forms form(s) _id of interest
	 * @param {String or Number} page number indicating the page of results (1 page = 32 documents)
	 * @param {String} start formatted date for start of period of interest
	 * @param {String} end  formatted date for end of period of interest
	 * @param {String or Array} editor form editor(s) _id(s) of interest, the 'created_by' in the db
	 */
	function forms_list_organization_group_changes(user, forms, page, start, end, editor) {

		if (!user) user = "";
		if (!forms) forms = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!editor) editor = "";

		return get("/v2/org/forms/submissions/change/history", {
			page: page,
			user: user,
			forms: forms,
			start: start,
			end: end,
			editor: editor
		});
	}

	function forms_list_organization_group_combined_changes(user, forms, page, start, end, editor) {

		if (!user) user = "";
		if (!forms) forms = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!editor) editor = "";

		return get("/v2/org/forms/submissions/change/combined/history", {
			page: page,
			user: user,
			forms: forms,
			start: start,
			end: end,
			editor: editor
		});
	}

	function forms_mark_confirm__combined_changes(submission, owner) {
		if (!submission) submission = "";
		if (!owner) submission = "";

		return get("/v2/org/forms/submissions/change/confirm/viewed", {
			submission: submission,
			owner: owner,
		});
	}

	function group_confirm_viewed() {
		return post("/v2/org/group/current/update/confirm");
	}

	function group_check_viewed() {
		return get("/v2/org/group/current/update/check");
	}

	// Returns the definition of specified workflow
	function workflow_definitions(workflow) {
		if (!workflow) workflow = "";
		return get("/v2/org/workflow/definitions", {
			workflow: workflow
		});
	}

	// Returns a list of all a group's ongoing workflows
	function workflow_ongoing(workflow) {
		if (!workflow) workflow = "";
		return get("/v2/org/workflow/history/ongoing", {
			workflow: workflow
		});
	}

	// Returns a list of the group's workflow actions history
	function workflow_action_history(user, page, start, end, workflow, action, actor) {
		if (!user) user = ""; // the owner of the workflow
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!workflow) workflow = "";
		if (!action) action = "";
		if (!actor) actor = ""; // the person taking an action (organization defined)

		return get("/v2/org/workflow/history/action", {
			user: user,
			page: page,
			start: start,
			end: end,
			workflow: workflow,
			action: action,
			actor: actor
		});
	}

	function link_workflow_externals(workflow, name, link) {
		return post("/v2/org/workflow/externals/link", {
			workflow: workflow,
			name: name,
			link: link
		});
	}

	function unlink_workflow_externals(workflow, name) {
		return post("/v2/org/workflow/externals/unlink", {
			workflow: workflow,
			name: name,
		});
	}

	// Returns a group member's blood oxygen and heart rate history
	function bloodoxygen_history(user, page, start, end) {
		if (!user) user = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";

		return get("/v2/org/observations/bloodoxygen/history", {
			page: page,
			user: user,
			start: start,
			end: end
		});
	}

	// Returns a group member's body temperature history
	function bodytemperature_history(user, page, start, end) {
		if (!user) user = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";

		return get("/v2/org/observations/bodytemperature/history", {
			page: page,
			user: user,
			start: start,
			end: end
		});
	}

	// Returns a group member's blood pressure history
	function bloodpressure_history(user, page, start, end) {
		if (!user) user = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";

		return get("/v2/org/observations/bloodpressure/history", {
			page: page,
			user: user,
			start: start,
			end: end
		});
	}

	// Returns a group member' weight history
	function weight_history(user, page, start, end) {
		if (!user) user = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";

		return get("/v2/org/observations/weight/history", {
			page: page,
			user: user,
			start: start,
			end: end
		});
	}

	// Returns a group member's blood sugar level history
	function blood_sugar_history(user, page, start, end) {
		if (!user) user = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";

		return get("/v2/org/observations/glucose/history", {
			page: page,
			user: user,
			start: start,
			end: end
		});
	}

	function steps_cumulative_history(user, page, start, end) {
		if (!user) user = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";

		return get("/v2/org/steps/history/cumulative", {
			page: page,
			user: user,
			start: start,
			end: end
		});
	}
	/**
	 * Retrieves a User's automated survey settings
	 */
	function auto_survey_retrieve(managee) {
		return get("/v2/org/users/survey/setting/get", {
			managee: managee
		});
	}

	/**
	 * Updates a User's automated survey settings
	 */
	function auto_survey_settings(setting, managee) {
		return post("/v2/org/users/survey/setting/update", {
			survey_setting: setting,
			managee: managee
		});
	}

	/**
	 * Returns a list of surveys optionally filtered by paramater values
	 */
	function group_history(users, page, dates, survey, state, senders) {
		if (!users) users = [];
		if (!page) page = 0;
		if (!dates) dates = [];
		if (!survey) survey = [];
		if (!state) state = [];
		if (!senders) senders = [];
		return get("/v2/org/users/survey/history/group", {
			users: users,
			page: page,
			dates: dates,
			survey: survey,
			state: state,
			senders: senders
		});
	}

	/**
	 * Returns a list of users in a group that have 'confirmed' careplan changes
	 */
	function show_confirmed_users() {
		return get("/v2/org/users/careplan/changes/confirmed/notification");
	}

	function post_committed_changes(user, section, change) {
		return post("/v2/org/users/careplan/changes/comitted/add", {
			user: user,
			section: section,
			change: change
		});
	}

	function get_user_careplan(user) {
		return get("/v2/org/users/careplan/data", {
			user: user
		});
	}

	function get_confirmed_changes(user, section) {
		return get("/v2/org/users/careplan/changes/confirmed/list", {
			user: user,
			section: section
		});
	}

	function get_users_full_data(user) {
		return get("/v2/org/users/data", {
			user: user
		});
	}

	function get_users_full_data_list(users) {
		return get("/v2/org/users/data/list", {
			users: users
		});
	}

	function update_careplan_number(user, number) {
		return post("/v2/org/users/careplan/number/update", {
			user: user,
			patientNumber: number
		});
	}

	function get_careplan_number(user) {
		return get("/v2/org/users/careplan/number/data", {
			user: user
		});
	}

	function metrics_listHistory(staff, users, page, start, end, metrics) {
		if (!staff) staff = "";
		if (!users) users = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!metrics) metrics = "";

		return get("/v2/org/metrics/history", {
			page: page,
			staff: staff,
			users: users,
			start: start,
			end: end,
			metrics: metrics
		});

	}

	function metrics_listCumulative(data) {
		var page = data.page;

		return get("/v2/org/metrics/cumulative", {
			page: page,
		});
	}

	function metrics_listCumulative_total(data) {
		var page = data.page;

		return get("/v2/org/metrics/cumulative/total", {
			page: page,
		});
	}

	function metrics_listCumulative_total_inactive(data) {
		var page = data.page;

		return get("/v2/org/metrics/cumulative/inactive/total", {
			page: page,
		});
	}

	function metrics_listCumulative_total_active(data) {
		var page = data.page;

		return get("/v2/org/metrics/cumulative/active/total", {
			page: page,
		});
	}

	function forms_list_organization_group() {
		return get("/v2/org/forms/group/list");
	}

	function forms_list_type(type) {
		var target = type || "group";
		return get("/v2/org/forms/list/type", {
			type: target
		});
	}

	function forms_list_staff_forms(staff) {
		return get("/v2/org/forms/staff/list", {
			staff: staff
		});
	}

	function forms_list_organization(targetType) {
		var target = targetType || null;

		return get("/v2/org/forms/org/list", {
			targetType: target
		});
	}

	function forms_add_user_form(user, form) {
		return post("/v2/org/forms/users/add", {
			user: user,
			form: form
		});
	}

	function forms_remove_user_form(user, form) {
		return post("/v2/org/forms/users/remove", {
			user: user,
			form: form
		});
	}

	function forms_add_staff_form(staff, form) {
		return post("/v2/org/forms/staff/add", {
			staff: staff,
			form: form
		});
	}

	function forms_remove_staff_form(staff, form) {
		return post("/v2/org/forms/staff/remove", {
			staff: staff,
			form: form
		});
	}

	/**
	 * Should have the following fields:
	 * icon
	 * localization
	 * formType
	 * schema
	 */
	function forms_create(data) {
		return post("/v2/org/forms/create", data);
	}

	function forms_update(form, data) {
		var toSubmit = xtend(data, {
			form: form
		});
		return post("/v2/org/forms/update", toSubmit);
	}

	function forms_remove(form) {
		return post("/v2/org/forms/remove", {
			form: form
		});
	}

	function templates_create(data) {
		var content = data.content;
		var responseType = data.responseType;

		return post("v2/org/reminders/template/create", {
			content: content,
			responseType: responseType
		});
	}

	function templates_update(data) {
		var content = data.content;
		var responseType = data.responseType;
		var templateId = data.templateId;

		return post("v2/org/reminders/template/update", {
			templateId: templateId,
			content: content,
			responseType: responseType
		});
	}

	function templates_remove(templateId) {
		return post("v2/org/reminders/template/remove", {
			templateId: templateId
		});
	}

	function templates_list() {
		return get("/v2/org/reminders/template/list");
	}

	/**
	 * [permissionUpdate description]
	 * @param  {[type]} user        [description]
	 * @param  {[type]} manager     [description]
	 * @param  {[type]} permissions [description]
	 * @return {[type]}             [description]
	 */
	function permissionUpdate(user, manager, permissions) {
		return post("/v2/org/manage/permission/update", {
			user: user,
			manager: manager,
			permission: permissions
		});
	}

	/**
	 * Returns a Manager's permissions for a given User
	 * @param  {String} user    ._id of user
	 * @param  {String} manager ._id of manager
	 * @return {Object}         Manager permissions for User
	 */
	function permissionList(user, manager) {
		return get("/v2/org/manage/permission/list", {
			user: user,
			manager: manager
		});
	}

	/**
	 * Causes the battery level of the device to be written do db
	 * for retrieval under a person's device data.
	 * @param  {number} data the battery level
	 * @return {Promise}     Resolves to batery level posted in to dbase
	 */
	function battery_level(level) {
		return post("/v2/org/devices/batterylevel", {
			batterylevel: level
		});
	}

	function update_nameonly(user, data) {
		return post("/v2/org/users/update", xtend(data, {
			user: user
		}));
	}

	function update_user_type(user, type) {
		return post("/v2/org/users/type/update", {
			user: user,
			type: type
		});
	}

	function update_inactive(user, inactive, removeManagers, stopWorkflows, removeContacts) {
		return post("/v2/org/users/inactive/update", {
			inactive: inactive,
			user: user,
			remove: removeManagers,
			stopWorkflows,
			removeContacts,
		});
	}

	function get_group_status() {
		return get("/v2/org/users/inactive/list");
	}

	function get_user_status(who) {
		return get("/v2/org/users/inactive/status", {
			who: who
		});
	}

	/**
	 * Looks up the list of users that are in the current user's group. Only works with staff accounts in a group
	 *
	 * @deprecated  use listWithFilters instead
	 *
	 * @return {Promise} Resolves to a list of ids of users in the group
	 */
	function get_group_user_list(query, page, status) {
		if (page === undefined || page === null) page = "";
		if (!query) query = "";
		if (!status) status = "";

		return get("/v2/org/users/list", {
			query: query,
			page: page,
			status: status
		});
	}

	/**
	 * Lists patients in an orgGroup.
	 * @param   {Object}    filters               filters to apply to the query
	 * @param   {String}   [filters.query]        query string to filter on
	 * @param   {Boolean}  [filters.status]       inactive state of the user
	 * @param   {String[]} [filters.state]        user state
	 * @param   {String[]} [filters.manageGroups] manage groups to filter on
	 * @param   {Number}   [pagination.page]      page number
	 * @returns {Promise}                         Resolves to array of managed user ids matching filters.
	 */
	function listWithFilters(filters, pagination = {}) {
		const { query, status, state, manageGroups } = filters;
		return get("/v2/org/users/list", {
			query,
			status,
			state,
			manageGroups,
			...pagination,
		});
	}

	/**
	 * Lists patients in an orgGroup sorted by current status.
	 * @param   {Object}    filters               filters to apply to the query
	 * @param   {String}   [filters.query]        query string to filter on
	 * @param   {Boolean}  [filters.status]       inactive state of the user
	 * @param   {String[]} [filters.state]        user state
	 * @param   {String[]} [filters.manageGroups] manage groups to filter on
	 * @param   {Number}   [page]                 number of the page to retrieve
	 * @returns {Promise}                         Resolves to array of managed user ids matching filters.
	 */
	function listByCurrentStatus(filters, page) {
		const { query, status, state, manageGroups } = filters;
		return get("/v2/org/users/list/status", {
			query,
			status,
			state,
			manageGroups,
			page,
		});
	}

	/**
	 * Lists patients in an orgGroup sorted by current status.
	 *
	 * @deprecated  use listByCurrentStatus instead
	 *
	 * @param   {String}  query  query string to filter on
	 * @param   {Number}  page   number of the page to retrieve
	 * @param   {Boolean} status inactive status of the user
	 * @returns {Promise}        Resolves to array of managed user ids matching filters.
	 */
	function get_group_user_by_status(query, page, status) {
		if (!(page || page === 0)) page = "";
		if (!query) query = "";

		return get("/v2/org/users/list/status", {
			query: query,
			page: page,
			status: status
		});
	}

	function list_patients(filters = {}, pagination = {}) {
		const { query, orgGroup, manageGroups, status, state, fields } = filters;
		const { sort, page } = pagination;

		return get("/v2/org/patients/list", {
			page,
			sort,
			query,
			orgGroup,
			manageGroups,
			status,
			state,
			fields
		});
	}

	/**
	 * Looks up the list of users that are in the current user's group
	 * AND that have an assigned device eg. bracelete.
	 * Only works with staff accounts in a group
	 * @return {Promise} Resolves to a list of ids of users in the group
	 */
	function get_group_users_assigned(query, page, status) {
		if (!query) query = "";
		if (!page) page = "";
		if (!status) status = "";

		return get("/v2/org/users/list/assigned", {
			query: query,
			page: page,
			status: status
		});
	}

	function get_users_from_emr(query) {
		if (!query) query = "";

		return get("/v2/org/users/listEMR", {
			query: query
		});
	}

	function get_group_user_basic(query, page) {
		if (!query) query = "";
		if (!page) page = "";
		return get("/v2/org/users/list_basic", {
			query: query,
			page: page
		});
	}

	/**
	 * Creates a new user and adds it to the group.
	 * @param  {String}  fname The user's first name
	 * @param  {String}  lname The user's last name
	 * @return {Promise}       Resolves if the user was added successfully
	 */
	function create_group_user(fname, lname, patientNumber, managers, language, data) {
		const submitData = data ? data : {
			fname,
			lname,
			patientNumber,
			managers,
			language
		};

		return post("/v2/org/users/create", {
			data: submitData
		});
	}

	function create_group_mobile(fname, lname, patientNumber, managers, language, data) {
		const submitData = data ? data : {
			fname: fname,
			lname: lname,
			patientNumber: patientNumber,
			managers: managers,
			language: language
		};

		return post("/v2/org/users/create/mobile", {
			data: submitData
		});
	}

	function create_group_simplified(fname, lname, patientNumber, managers, language, data) {
		const submitData = data ? data : {
			fname: fname,
			lname: lname,
			patientNumber: patientNumber,
			managers: managers,
			language: language
		};

		return post("/v2/org/users/create/simplified", {
			data: submitData
		});
	}

	/**
	 * Removes a user from the group
	 * @param  {String}  who The id of the user to remove
	 * @return {Promise}     Resolves if removal was successfull
	 */
	function remove_group_user(who) {
		return post("/v2/org/users/remove", {
			who: who
		});
	}

	function get_user_token(user) {
		return get("/v2/org/users/token", {
			who: user
		});
	}

	function get_user_statuses(user) {
		return get("/v2/org/users/status", {
			who: user
		});
	}

	function list_user_contacts(query, page, user) {
		if (!query) query = "";
		if (!page) page = "";
		return get("/v2/org/users/contacts/list", {
			who: user,
			query: query,
			page: page
		});
	}

	/**
	 * Looks up the history of urgency calls that occured in the current user's
	 * group. Can specify which page of history to load. Loads 32 items at a time
	 * @return {Promise} Resolves to list of urgency call data
	 */
	function list_group_urgency(callers, recipients, page, start, end, status) {
		if (!callers) callers = "";
		if (!recipients) recipients = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!status) status = "";
		return get("/v2/org/urgency/list/group", {
			page: parseInt(page) || 0,
			callers: callers,
			recipients: recipients,
			start: start,
			end: end,
			status: status
		});
	}

	function add_urgency_staff(user, who) {
		return post("/v2/org/urgency/add/staff", {
			user: user,
			who: who
		});
	}

	function remove_urgency_contact(user, who) {
		return post("/v2/org/urgency/remove", {
			user: user,
			who: who
		});
	}

	function list_urgency_contacts(user) {
		return get("/v2/org/urgency/list/user", {
			user: user
		});
	}

	function get_urgency_preferences(user) {
		return get("/v2/org/urgency/preferences/data", {
			user: user
		});
	}

	function update_urgency_preferences(user, updates) {
		var data = xtend(updates, {
			user: user
		});
		return post("/v2/org/urgency/preferences/update", data);
	}

	function list_group_reminder_history(users, page, startShown, endShown, startRespond, endRespond, content, state, responseType) {
		if (!startShown) startShown = "";
		if (!endShown) endShown = "";
		if (!startRespond) startRespond = "";
		if (!endRespond) endRespond = "";
		if (!responseType) responseType = "";
		if (!page) page = "";
		if (!content) content = "";
		if (!state) state = "";
		if (!users) users = "";
		return get("/v2/org/reminders/history/list/group", {
			page: parseInt(page) || 0,
			startShown: startShown,
			endShown: endShown,
			startRespond: startRespond,
			endRespond: endRespond,
			responseType: responseType,
			content: content,
			state: state,
			users: users,
		});
	}

	function list_group_reminder_response_history(users, page, startShown, endShown, startRespond, endRespond, content, state, responseType) {
		if (!startShown) startShown = "";
		if (!endShown) endShown = "";
		if (!startRespond) startRespond = "";
		if (!endRespond) endRespond = "";
		if (!responseType) responseType = "";
		if (!page) page = "";
		if (!content) content = "";
		if (!state) state = "";
		if (!users) users = "";
		return get("/v2/org/reminders/history/list/group/responses", {
			page: parseInt(page) || 0,
			startShown: startShown,
			endShown: endShown,
			startRespond: startRespond,
			endRespond: endRespond,
			responseType: responseType,
			content: content,
			state: state,
			users: users,
		});
	}

	function list_group_reminder_pending_history(users, page, startShown, endShown, content, state) {
		if (!startShown) startShown = "";
		if (!endShown) endShown = "";
		if (!page) page = "";
		if (!content) content = "";
		if (!state) state = "";
		if (!users) users = "";
		return get("/v2/org/reminders/history/list/group/pending", {
			page: parseInt(page) || 0,
			startShown: startShown,
			endShown: endShown,
			content: content,
			state: state,
			users: users,
		});
	}

	function list_group_reminder_data(reminders) {
		return get("/v2/org/reminders/list/group", {
			reminders: reminders
		});
	}

	function list_org_managers(query, page) {
		if (!query) query = "";
		if (!page) page = "";
		return get("/v2/org/managers/list", {
			query: query,
			page: parseInt(page) || 0
		});
	}

	function add_org_manager(who) {
		return post("/v2/org/managers/add", {
			who: who
		});
	}

	function remove_org_manager(who) {
		return post("/v2/org/managers/remove", {
			who: who
		});
	}

	/**
	 * Gets the ID of the org that the org manager is currently in
	 * @return {Promise} Resolves to the id of the org that the current org manager is in if successfull
	 */
	function get_org_id() {
		return get("/v2/org/id");
	}

	function get_public_org_data(organizations) {
		return get("/v2/org/public", {
			organizations: organizations
		});
	}

	function get_org_data() {
		return get("/v2/org/data");
	}

	function get_group_list(query, page) {
		if (!query) query = "";
		return get("/v2/org/group/list", {
			query: query,
			page: page
		});
	}

	function update_group(group, data) {
		return post("/v2/org/group/update", xtend(data, {
			group: group
		}));
	}

	function get_group_data(group) {
		return get("/v2/org/group/data", {
			group: group
		});
	}

	function create_group(name) {
		return post("/v2/org/group/create", {
			name: name
		});
	}

	function group_settings() {
		return get("/v2/org/group/settings");
	}

	function update_current_group(data) {
		return post("/v2/org/group/current/update", data);
	}

	function get_current_group_data() {
		return get("/v2/org/group/current/data");
	}

	function get_current_group() {
		return get("/v2/org/group/current");
	}

	function set_administrator(group, admin) {
		return post("/v2/org/group/administrator/set", {
			group: group,
			who: admin
		});
	}

	function remove_administrator(group) {
		return post("/v2/org/group/administrator/remove", {
			group: group
		});
	}

	function getStaffOrgData() {
		return get("/v2/org/staff/orgData");
	}

	function list_staff(query, page) {
		if (!query) query = "";
		if (!page) page = "";
		return get("/v2/org/staff/list", {
			query: query,
			page: page
		});
	}

	function add_staff(who) {
		return post("/v2/org/staff/add", {
			who: who
		});
	}

	function remove_staff(who) {
		return post("/v2/org/staff/remove", {
			who: who
		});
	}

	function list_user_managers(user, query, page) {
		return get("/v2/org/manage/list/user", {
			user: user,
			query: query,
			page: parseInt(page) || 0
		});
	}

	function add_user_manager(user, manager, permissions) {
		return post("/v2/org/manage/add", {
			user: user,
			manager: manager,
			permissions: permissions
		});
	}

	function add_user_manager_multi(users, managers, permissions) {
		return post("/v2/org/manage/add/multi", {
			users: users,
			managers: managers,
			permissions: permissions
		});
	}

	function remove_user_manager(user, manager) {
		return post("/v2/org/manage/remove", {
			user: user,
			manager: manager
		});
	}

	function remove_user_manager_multi(users, managers) {
		return post("/v2/org/manage/remove/multi", {
			users: users,
			managers: managers
		});
	}

	function set_default_manager_permissions(permissions) {
		return post("/v2/org/managers/default/permissions/set", {
			permissions: permissions
		});
	}

	function get_default_manager_permissions() {
		return get("/v2/org/managers/default/permissions");
	}

	function list_preset_manager_permissions() {
		return get("/v2/org/managers/preset/permissions/list");
	}

	/**
	 *
	 * @param {Object} data
	 * @param {Object} data.permissions
	 * @param {string} data.name
	 */
	function create_preset_manager_permissions(data) {
		return post("/v2/org/managers/preset/permissions/create", { data });
	}

	/**
	 *
	 * @param {Object} id string
	 * @param {Object} data
	 * @param {Object} data.permissions
	 * @param {string} data.name
	 */
	function update_preset_manager_permissions(id, data) {
		return post("/v2/org/managers/preset/permissions/update", { id, data });
	}

	/**
	 *
	 * @param {string} id
	 */
	function remove_preset_manager_permissions(id) {
		return post("/v2/org/managers/preset/permissions/remove", { id });
	}

	function list_machines_user() {
		return get("/v2/org/machines/list/user");
	}

	function list_machines_staff() {
		return get("/v2/org/machines/list/staff");
	}

	function list_devices() {
		return get("/v2/org/devices/list");
	}

	function list_devices_user() {
		return get("/v2/org/devices/list/user");
	}

	function associate_devices(mac, user) {
		return post("/v2/org/devices/associate", {
			mac: mac,
			user: user
		});
	}

	function unassociate_devices(user) {
		return post("/v2/org/devices/unassociate", {
			user: user
		});
	}

	function set_device_contact(contact, user) {
		return post("/v2/org/devices/contact", {
			user: user,
			contact: contact
		});
	}

	function get_devices_data(user) {
		return get("/v2/org/devices/data", {
			user: user
		});
	}

	function update_devices(data, user) {
		return post("/v2/org/devices/update", xtend(data, {
			user: user
		}));
	}

	/**
	 * This series of api's 'gets' arrays of 'latest calls' from:
	 * 	a) all staff to any members of the group
	 *  b) all users to any members of the group
	 *  c) a particular staff/user to any members of the group
	 * @return {Array} Listing the individuals by _id.
	 */

	function group_calls_report(start, end, filename, language) {
		return get("/v2/org/group/groupcalls/report", {
			start: start,
			end: end,
			filename: filename,
			language: language
		});
	}

	function group_calls_all(callers, recipients, page, start, end, status) {
		if (!callers) callers = "";
		if (!recipients) recipients = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!status) status = "";
		return get("/v2/org/group/groupcalls", {
			page: page,
			callers: callers,
			recipients: recipients,
			start: start,
			end: end,
			status: status
		});
	}

	function group_calls_staff(page) {
		return get("/v2/org/group/staffcalls", {
			page: page
		});
	}

	function group_calls_users(page) {
		return get("/v2/org/group/usercalls", {
			page: page
		});
	}

	function group_calls_member(page, user) {
		if (page === undefined) page = "";
		if (user === undefined) user = "";
		return get("/v2/org/group/membercalls", {
			page: page,
			user: user
		});
	}

	function wander_history(query, page, start, end, status) {
		if (!query) query = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!status) status = "";
		return get("/v2/org/wander/history", {
			page: page,
			query: query,
			start: start,
			end: end,
			status: status
		});
	}

	function wander_latest(page) {
		return get("/v2/org/wander/latest", {
			page: page
		});
	}

	function fall_history(query, page, start, end, status) {
		if (!query) query = "";
		if (!page) page = "";
		if (!start) start = "";
		if (!end) end = "";
		if (!status) status = "";
		return get("/v2/org/falls/history", {
			page: page,
			query: query,
			start: start,
			end: end,
			status: status
		});
	}

	function get_preferences(id) {
		return get("/v2/org/staff/preferences", {
			id: id
		});
	}

	function set_preferences(id, preferences) {
		return post("/v2/org/staff/preferences/update", {
			id: id,
			preferences: preferences
		});
	}

	function send_email_invitation(email, careCoordinators, fname, lname, patientNumber, manageGroup, language) {
		return post("/v2/org/users/invitation/send", {
			email: email,
			careCoordinators: careCoordinators,
			fname: fname,
			lname: lname,
			patientNumber: patientNumber,
			manageGroup: manageGroup,
			language: language
		});
	}

	function get_email_invitation() {
		return get("/v2/org/users/invitation/list");
	}

	function remove_email_invitation(id) {
		return post("/v2/org/users/invitation/remove", {
			id: id
		});
	}

	function callgroup_list() {
		return get("/v2/org/callgroups/list");
	}

	function callgroup_create(name, description, permissions, file) {
		return upload("/v2/org/callgroups/create", {
			name: name,
			description: description,
			permissions: permissions
		}, "file", file || {});
	}

	function callgroup_remove(group) {
		return post("/v2/org/callgroups/remove", {
			group: group
		});
	}

	function callgroup_member_add(group, who) {
		return post("/v2/org/callgroups/members/add", {
			group: group,
			who: who
		});
	}

	function callgroup_member_remove(group, who) {
		return post("/v2/org/callgroups/members/remove", {
			group: group,
			who: who
		});
	}

	function callgroup_update(group, name, description, permissions, file) {
		return upload("/v2/org/callgroups/update", {
			group: group,
			name: name,
			description: description,
			permissions: permissions
		}, "file", file || {});
	}

	function get_existing_invitation() {
		return get("/v2/org/users/invitation/existing/list");
	}

	function remove_existing_invitation(id) {
		return post("/v2/org/users/invitation/existing/remove", {
			id: id
		});
	}

	function get_incoming_user_invitation() {
		return get("/v2/org/users/invitation/incoming", {});
	}

	function accept_incoming_user_invitation(request) {
		return post("/v2/org/users/invitation/accept", {
			request: request
		});
	}

	function deny_incoming_user_invitation(request) {
		return post("/v2/org/users/invitation/deny", {
			request: request
		});
	}

	function resource_create(name, data) {
		return post("/v2/org/resources/create", {
			name: name,
			data: data
		});
	}

	function resource_remove(id) {
		return post("/v2/org/resources/remove", {
			resource: id
		});
	}

	function resource_update(id, name, data) {
		return post("/v2/org/resources/update", {
			resource: id,
			name: name,
			data: data
		});
	}

	function resource_user_add(id, who) {
		return post("/v2/org/resources/user/add", {
			resource: id,
			who: who
		});
	}

	function resource_user_remove(id, who) {
		return post("/v2/org/resources/user/remove", {
			resource: id,
			who: who
		});
	}

	function resource_list() {
		return get("/v2/org/resources/list");
	}

	function resource_list_all(page) {
		return get("/v2/org/resources/list/all", {
			page
		});
	}

	function resource_user_list(who) {
		return get("/v2/org/resources/user/list", {
			who: who
		});
	}

	function livechat_create(name, description, hasSchedule, schedule) {
		return post("/v2/org/livechat/create", {
			name: name,
			description: description,
			hasSchedule: hasSchedule,
			schedule: schedule
		});
	}

	function livechat_update(name, description, hasSchedule, schedule, group) {
		return post("/v2/org/livechat/update", {
			name: name,
			description: description,
			hasSchedule: hasSchedule,
			schedule: schedule,
			group: group
		});
	}

	function livechat_remove(group) {
		return post("/v2/org/livechat/remove", {
			group: group
		});
	}


	function livechat_member_add(group, who) {
		return post("/v2/org/livechat/members/add", {
			group: group,
			who: who
		});
	}

	function livechat_member_remove(group, who) {
		return post("/v2/org/livechat/members/remove", {
			group: group,
			who: who
		});
	}

	function livechat_list() {
		return get("/v2/org/livechat/list");
	}

	function latest_steps(who) {
		return get("/v2/org/steps/latest", {
			who: who
		});
	}

	function latest_bloodsugar(who) {
		return get("/v2/org/observations/glucose/latest", {
			who: who
		});
	}

	function latest_bloodpressure(who) {
		return get("/v2/org/observations/bloodpressure/latest", {
			who: who
		});
	}

	function latest_bodytemperature(who) {
		return get("/v2/org/observations/bodytemperature/latest", {
			who: who
		});
	}

	function latest_bloodoxygen(who) {
		return get("/v2/org/observations/bloodoxygen/latest", {
			who: who
		});
	}

	function latest_weight(who) {
		return get("/v2/org/observations/weight/latest", {
			who: who
		});
	}

	function get_total_patients(filters) {
		const {
			inactive,
			state = [],
			manageGroups = [],
			isManager = false,
		} = filters;
		return get("/v2/org/users/count", {
			inactive,
			state,
			manageGroups,
			isManager,
		});
	}

	function get_total_red_patients(filters) {
		const {
			inactive,
			state = [],
			manageGroups = [],
			isManager = false,
		} = filters;
		return get("/v2/org/users/count/red", {
			inactive,
			state,
			manageGroups,
			isManager,
		});
	}

	function get_total_yellow_patients(filters) {
		const {
			inactive,
			state = [],
			manageGroups = [],
			isManager = false,
		} = filters;
		return get("/v2/org/users/count/yellow", {
			inactive,
			state,
			manageGroups,
			isManager,
		});
	}

	function get_total_green_patients(filters) {
		const {
			inactive,
			state = [],
			manageGroups = [],
			isManager = false,
		} = filters;
		return get("/v2/org/users/count/green", {
			inactive,
			state,
			manageGroups,
			isManager,
		});
	}

	function thresholds_list(id) {
		return get("/v2/org/thresholds/list", {
			who: id
		});
	}

	function thresholds_update(id, thresholds) {
		return post("/v2/org/thresholds/update", {
			who: id,
			thresholds: thresholds
		});
	}

	function compliant_list() {
		return get("/v2/org/compliancy/list");
	}

	function compliant_update(schedules, timezone) {
		return post("/v2/org/compliancy/update", {
			schedules: schedules,
			timezone: timezone
		});
	}

	function thresholds_default_list() {
		return get("/v2/org/thresholds/default");
	}

	function thresholds_default_update(thresholds) {
		return post("/v2/org/thresholds/default/update", {
			thresholds: thresholds
		});
	}

	function get_user_compliancy(id) {
		return get("/v2/org/compliancy", {
			who: id
		});
	}

	function list_note(who, schema, page) {
		return get("/v2/org/forms/submission/list", {
			who: who,
			schema: schema,
			page: page
		});
	}

	function create_note(name, data, who) {
		return post("/v2/org/forms/submission/core", {
			name: name,
			data: data,
			who: who
		});
	}

	function update_note(data, submission, who) {
		return post("/v2/org/forms/submission/update", {
			submission: submission,
			data: data,
			who: who
		});
	}

	function remove_note(submission, who) {
		return post("/v2/org/forms/submission/remove", {
			submission: submission,
			who: who
		});
	}

	function workflow_autostart_set(settings) {
		return post("/v2/org/workflow/autostart/set", {
			settings: settings
		});
	}

	function workflow_autostart_get() {
		return get("/v2/org/workflow/autostart/get");
	}

	function workflow_autostart_remove() {
		return post("/v2/org/workflow/autostart/remove");
	}

	function get_org_autologout() {
		return get("/v2/org/managers/autologout/list");
	}

	function set_org_autologout(toggle) {
		return post("/v2/org/managers/autologout", {
			autologout: toggle
		});
	}

	function get_org_multifactor() {
		return get("/v2/org/managers/multifactor/list");
	}

	function set_org_multifactor(toggle) {
		return post("/v2/org/managers/multifactor", {
			multifactor: toggle
		});
	}

	function get_autologout() {
		return get("/v2/org/staff/autologout");
	}

	function get_multifactor() {
		return get("/v2/org/staff/multifactor");
	}

	// eslint-disable-next-line no-unused-vars
	function get_user_orggroup(id) {
		return get("/v2/org/users/orggroup", {
			who: id
		});
	}

	function clearverification_staff(who) {
		return get("/v2/org/staff/clearverification", {
			who: who
		});
	}

	function get_group_user_by_managegroup(query, group, page) {
		return get("/v2/org/users/list/managegroup", {
			query: query,
			managegroup: group,
			page: page
		});
	}

	function get_group_user_by_status_managegroup(query, status, group, page) {
		return get("/v2/org/users/list/status_managegroup", {
			query: query,
			status: status,
			managegroup: group,
			page: page
		});
	}

	function group_custom_properties() {
		return get("/v2/org/group/custom/properties");
	}

	function update_user_device_info(who, deviceInfo) {
		return post("/v2/org/users/deviceinfo/update", {
			who: who,
			deviceInformation: deviceInfo
		});
	}

	function patients(orgGroups, query, pagination) {
		return newGet("/v2/org/users/patients", {
			orgGroups,
			query,
			pagination,
		});
	}

	function patientState(patientId, state) {
		return post("/v2/org/users/patient/state", {
			patientId,
			state,
		});
	}

	function handle_testmode_enable(id) {
		return post("/v2/org/users/testmode/enable", {
			user: id
		});
	}

	function handle_testmode_disable(id) {
		return post("/v2/org/users/testmode/disable", {
			user: id
		});
	}

	function handle_testmode_enable_bulk(ids) {
		return post("/v2/org/users/testmode/enable/bulk", {
			users: ids
		});
	}

	function handle_testmode_disable_bulk(ids) {
		return post("/v2/org/users/testmode/disable/bulk", {
			users: ids
		});
	}

	function get_recent_readings_of_user(userId) {
		return get("/v2/org/observations/user/recent/readings", {
			userId
		});
	}

	function get_recent_readings_of_users(userList) {
		return get("/v2/org/observations/users/recent/readings", {
			userList
		});
	}

	function get_recent_readings_of_group(query, sort, page, itemsPerPage, indicators, status) {
		return get("/v2/org/observations/group/recent/readings", {
			query,
			sort,
			page,
			itemsPerPage,
			indicators,
			status
		});
	}

	function fetchAuditLog({
		start,
		end,
		event,
		performer,
		target,
		group,
		last
	}) {
		return get("/v2/audit/fetch", {
			start,
			end,
			event,
			performer,
			target,
			group,
			last
		});
	}
};
